// @flow
import {camelCase} from 'lodash';

export const generateId = (text: string): string =>
  camelCase(text.slice(0, 16));
